(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-instagram-v1"] && !Shopify.designMode) return;
  try {
    
// No se necesita código JavaScript adicional

  } catch(e) { console.error(e); }
})();
})();
